var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "13", height: "12", viewBox: "0 0 13 12", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "location-outline-icon"
    ),
    React.createElement("path", { d: "M10.408 1.176c1.331-.486 1.904.158 1.285 1.426l-3.81 7.8c-.623 1.274-1.456 1.204-1.908-.128 0 0-.3-1.514-1.31-2.636-1.01-1.121-2.484-1.577-2.484-1.577C.889 5.49.926 4.633 2.252 4.15l8.156-2.974z", stroke: "#222", strokeWidth: ".8", fill: "none", fillRule: "evenodd", strokeLinecap: "round" })
  );
});


// WEBPACK FOOTER //
// ../public/images/icons/location-outline-small.svg?react-svg